export default "__VITE_ASSET__0LcdbBHi__"